import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Home, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import SEO from "@/components/app/SEO";
import { api } from "@/lib/api";

export default function NotFoundPage() {
  const [q, setQ] = useState("");
  const [cats, setCats] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats((data || []).slice(0, 8))).catch(() => setCats([]));
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    nav(`/annuaire?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <>
      <SEO title="Page introuvable" description="La page que vous cherchez n'existe pas ou a été déplacée." noindex />
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <div className="text-7xl font-bold text-primary/30 mb-2">404</div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">Page introuvable</h1>
        <p className="text-muted-foreground mb-8">La page que vous cherchez n'existe pas ou a été déplacée. Vous pouvez rechercher un organisme, parcourir les catégories ou revenir à l'accueil.</p>

        <form onSubmit={submit} className="mb-8 flex gap-2 max-w-lg mx-auto">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un organisme…" className="pl-10" data-testid="404-search-input" />
          </div>
          <Button type="submit" className="bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="404-search-btn">Rechercher</Button>
        </form>

        {cats.length > 0 && (
          <div className="mb-10">
            <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Catégories populaires</div>
            <div className="flex flex-wrap gap-2 justify-center">
              {cats.map((c) => (
                <Link key={c.slug} to={`/categorie/${c.slug}`} className="text-xs px-3 py-1.5 rounded-full border border-border hover:bg-secondary transition-colors" data-testid={`404-cat-${c.slug}`}>
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button variant="outline" data-testid="404-home-btn"><Home className="h-4 w-4 mr-2" />Accueil</Button>
          </Link>
          <Link to="/aide">
            <Button variant="outline" data-testid="404-help-btn"><HelpCircle className="h-4 w-4 mr-2" />Centre d'aide</Button>
          </Link>
        </div>
      </div>
    </>
  );
}
